import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "../../utils/functions/getUrl";

import PostData from '../../services/PostData';

const Logout = ( { logged } ) => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  let history = useNavigate();
  

  const [formData, setFormData] = useState({ 
      user: "",
      password: "",
    }
  );

  function handleChange(event) {
    const { name, value, type, checked } = event.target
    setFormData(prevState => {
      return{
        ...prevState,
        // [event.target.name]: event.target.value
        [name]: type === "checkbox" ? checked : value
      }
    });
  };

  const handleLogout  = (e) => {
    console.log('handleLogout()');

    e.preventDefault();

    sessionStorage.clear();
    logged(false);
    
    console.log(`BASE_URL +"/": ${BASE_URL +"/"}`);
    history(BASE_URL +"/");
          
  }


  return (
    <Wrapper id="login--wrapper">
      {/* <Header>Login</Header> */}
      <Container id="login--container">
        <Content>
          <ContentHeader>
            PictureViewer
            <span>by rndWs.com</span>
          </ContentHeader>
          <Title>
            Are you sure you want to logout?
            <span>Yes i'm pretty sure! <span class="logout" onClick={handleLogout}>logout</span></span>
          </Title>
          
          <ButtonBelly>
            <span><Link to={BASE_URL +"/"}>Go to home page</Link></span>
          </ButtonBelly>
          
        </Content>
      </Container>
    </Wrapper>
  )
}

export default Logout;

const Wrapper = styled.div `
  width: 100%;
  height: 90vh;
  min-height: 90vh;
  color: #d1d1d1;
  background-color: transparent;
  font-size:2rem;
  /* padding: 10px 30px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Header = styled.div `
  /* text-align: center; */
`;

const Container = styled.div `
  /* width: 400px; */
`;
const Content = styled.div `
  padding-bottom: 2rem;
  border: 1px solid orange;
  background-color: rgba(0,0,0,0.4);
`;
const ContentHeader = styled.div `
  display: flex;
  flex-direction: column;

  text-align: center;
  background-color: #111;
  padding: 2rem 3rem;
  line-height: 1.3rem;

  span {
    font-size: 1rem;
  }
`;
const Title = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  font-size: 1.6rem;
  padding: 1rem 2.4rem;

  span {
    font-size: 1rem;
  }
  a, span.logout{
    color: #3e85f5;

    cursor: pointer;
  }
`;

const Form = styled.form `
  display: flex;
  flex-direction: column;
  
  padding: 1rem .5rem;

`;
const Input = styled.input `
  border: 1px solid #1b1b1b;
  background-color: #0e0e0e;
  color: #d1d1d1;
  font-size: 1.1rem;
  margin-top: .2rem;
  padding: 1rem .8rem;

`;
const Button = styled.button `
  color: #fff;
  border: 1px solid #1b1b1b;
  background-color: #029F85;
  border-radius: 5px;;
  font-size: 1rem;
  padding: 1rem .8rem;
  margin-top: .4rem;
`;

const ButtonBelly = styled.div `
  font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;
  
  span {
    font-size: 1rem;
    color: #029F85;
  }
`;